import * as React from 'react';

export const MetaIcon = (props) => {
  return (
    <svg
      width="34"
      height="23"
      viewBox="0 0 34 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_13437_29197)">
        <path
          d="M4.40985 14.9068C4.40985 16.1354 4.67903 17.0748 5.03087 17.6444C5.21836 17.9687 5.48835 18.2376 5.81341 18.4238C6.13847 18.6099 6.50702 18.7067 6.88162 18.7044C7.78633 18.7044 8.61397 18.481 10.2089 16.2739C11.4867 14.5058 12.9923 12.0296 14.0065 10.4659L15.7221 7.82994C16.9139 5.99929 18.291 3.96425 19.8748 2.58037C21.1649 1.45898 22.5577 0.833496 23.9595 0.833496C26.3128 0.833496 28.5545 2.19727 30.2701 4.75503C32.1477 7.55629 33.0624 11.0847 33.0624 14.7259C33.0624 16.8905 32.6358 18.481 31.9097 19.7375C31.2094 20.9527 29.8378 22.1668 27.5381 22.1668V18.7044C29.5072 18.7044 29.9953 16.8949 29.9953 14.8241C29.9953 11.8732 29.3073 8.59838 27.7916 6.25842C26.716 4.59866 25.3221 3.58449 23.7886 3.58449C22.1299 3.58449 20.7952 4.83545 19.2952 7.06596C18.4977 8.25102 17.679 9.69521 16.7597 11.3248L15.7478 13.1119C13.715 16.7162 13.2001 17.5372 12.1837 18.892C10.4055 21.2733 8.88427 22.1668 6.88162 22.1668C4.50591 22.1668 3.00364 21.1381 2.07882 19.5878C1.31373 18.3246 0.940674 16.6671 0.940674 14.7783L4.40985 14.9068Z"
          fill="#0081FB"
        />
        <path
          d="M3.67566 4.99915C5.26617 2.54749 7.56145 0.833008 10.1941 0.833008C11.7187 0.833008 13.2343 1.27978 14.817 2.57653C16.5483 3.98945 18.3912 6.31601 20.6954 10.1504L21.5208 11.5265C23.5134 14.846 24.6482 16.5527 25.3106 17.3591C26.1639 18.3934 26.7626 18.6994 27.5377 18.6994C29.5069 18.6994 29.995 16.89 29.995 14.8192L33.0553 14.7231C33.0553 16.8877 32.6287 18.4782 31.9027 19.7348C31.2091 20.9522 29.8375 22.1663 27.5377 22.1663C26.1081 22.1663 24.8415 21.8558 23.4408 20.5345C22.3641 19.5203 21.1053 17.7187 20.137 16.0992L17.2564 11.2875C15.8111 8.87266 14.4853 7.07217 13.718 6.26128C12.8914 5.38002 11.8315 4.32118 10.1382 4.32118C8.76774 4.32118 7.6039 5.28285 6.62994 6.75385L3.67566 4.99915Z"
          fill="url(#paint0_linear_13437_29197)"
        />
        <path
          d="M10.1386 4.32166C8.76811 4.32166 7.60427 5.28334 6.63031 6.75433C5.25313 8.83294 4.40985 11.9291 4.40985 14.9068C4.40985 16.1354 4.67903 17.0748 5.03087 17.6444L2.07324 19.5878C1.31373 18.3246 0.940674 16.6671 0.940674 14.7783C0.940674 11.3438 1.88336 7.76404 3.67603 4.99964C5.26654 2.54798 7.56183 0.833496 10.1944 0.833496L10.1386 4.32166Z"
          fill="url(#paint1_linear_13437_29197)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_13437_29197"
          x1="7.90323"
          y1="10.9468"
          x2="30.0184"
          y2="12.0637"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0064E1" />
          <stop offset="0.4" stopColor="#0064E1" />
          <stop offset="0.83" stopColor="#0073EE" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13437_29197"
          x1="5.56699"
          y1="16.3588"
          x2="5.56699"
          y2="8.20522"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop offset="1" stopColor="#0064E0" />
        </linearGradient>
        <clipPath id="clip0_13437_29197">
          <rect
            width="32.1184"
            height="21.3333"
            fill="white"
            transform="translate(0.940674 0.833496)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
